import {
  CREATE_FILTERS_WHERE_STAY_FAILURE,
  CREATE_FILTERS_WHERE_STAY_REQUEST,
  CREATE_FILTERS_WHERE_STAY_SUCCESS,
  DELETE_FILTERS_WHERE_STAY_FAILURE,
  DELETE_FILTERS_WHERE_STAY_REQUEST,
  DELETE_FILTERS_WHERE_STAY_SUCCESS,
  GET_FILTERS_WHERE_STAY_FAILURE,
  GET_FILTERS_WHERE_STAY_REQUEST,
  GET_FILTERS_WHERE_STAY_SUCCESS,
  UPDATE_FILTERS_WHERE_STAY_FAILURE,
  UPDATE_FILTERS_WHERE_STAY_REQUEST,
  UPDATE_FILTERS_WHERE_STAY_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: false,
  loading: false,
  data: null,
  success: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FILTERS_WHERE_STAY_REQUEST:
      console.log("REQUEST");
      state = {
        ...state,
        data: [],
        loading: true,
        error: false,
      };
      break;

    case GET_FILTERS_WHERE_STAY_SUCCESS:
      console.log("SUCCESS");
      state = {
        ...state,
        data: action.data,
        error: false,
        loading: false,
      };
      break;

    case GET_FILTERS_WHERE_STAY_FAILURE:
      console.log("FAILURE");
      state = {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
      break;

    case CREATE_FILTERS_WHERE_STAY_REQUEST:
      console.log("REQUESTED...");

      state = {
        ...state,
        loading: true,
        error: false,
        success: false,
      };
      break;

    case CREATE_FILTERS_WHERE_STAY_SUCCESS:
      console.log("SUCCESS =)");

      state = {
        ...state,
        loading: false,
        error: false,
        success: true,
      };
      break;

    case CREATE_FILTERS_WHERE_STAY_FAILURE:
      console.log("ERROR =(");

      state = {
        ...state,
        loading: false,
        error: true,
        success: false,
      };
      break;

    case UPDATE_FILTERS_WHERE_STAY_REQUEST:
      console.log("REQUEST =)");
      state = {
        ...state,
        loading: true,
        error: false,
        success: false,
      };
      break;

    case UPDATE_FILTERS_WHERE_STAY_SUCCESS:
      console.log("SUCCESS =)");
      state = {
        ...state,
        error: false,
        loading: false,
        success: true,
      };
      break;

    case UPDATE_FILTERS_WHERE_STAY_FAILURE:
      console.log("ERROR =(");
      state = {
        ...state,
        loading: false,
        error: action.data,
        success: false,
      };
      break;

    case DELETE_FILTERS_WHERE_STAY_REQUEST:
      console.log("REQUEST =)");
      state = {
        ...state,
        loading: true,
        error: false,
        success: false,
      };
      break;

    case DELETE_FILTERS_WHERE_STAY_SUCCESS:
      console.log("SUCCESS =)");
      state = {
        ...state,
        error: false,
        loading: false,
        success: true,
      };
      break;

    case DELETE_FILTERS_WHERE_STAY_FAILURE:
      console.log("ERROR =(");
      state = {
        ...state,
        data: [],
        loading: false,
        error: action.data,
        success: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default reducer;
